const FREE_GIFT_VARIANT_ID = 50852594745641; // Free gift product ID
const MIN_CART_TOTAL = 999; // The threshold for free gift eligibility (in your currency)

class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartNotification = this.closest("cart-notification");
      const lineItemIndex = this.dataset.index;
      cartNotification.deleteQuantity(lineItemIndex, 0); // Remove item
      cartNotification.closest(".cart-notification-product").classList.add("loading");
      cartNotification.closest(".cart-notification-product").firstElementChild.classList.remove("hidden");
      document.getElementById("mini-cart-drawer").classList.add("loading-bar");

      

    });
  }

 


}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("mini-cart-drawer");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.notification?.addEventListener("click", (event) => {
      if (!event.target.classList.contains("cart-notification__close")) return;
      this.close();
    });

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (
      !event.target.closest("select") &&
      !event.target.closest('[name="attributes[gift-wrapping]"]') &&
      !event.target.closest('[name="note"]') &&
      !event.target.closest("shipping-calculator") &&
      !event.target.closest("discount-code") &&
      !event.target.closest("gift-wrap-message")
    ) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
      document.querySelector(".cart_action_drawer_overlay").classList.add("active");
    }
  }

  open() {
    
    /*this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");*/

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    /*document.body.addEventListener("click", this.onBodyClick);*/
  }

  close() {
    document.getElementById("mini-cart-drawer").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClick);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      let renderSelector = document.getElementById(section.id);
      let renderCartItemCount = document.getElementById("cart-notification-count-mobile");
      if (renderSelector) {
        renderSelector.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id]);
        
         /*const itemssubtotalprice = parsedState.final_line_price / 100;
         console.log(itemssubtotalprice);
         if(itemssubtotalprice<1000){
          this.checkCartForFreeGift(cart);
         }*/
        
        
      }

      if (renderCartItemCount)
        renderCartItemCount.innerHTML = this.getSectionInnerHTML(parsedState.sections["cart-notification-count"]);
    });
    
    if (this.header) this.header.reveal();
    this.open();
    /* //this.checkCartForFreeGift(parsedState); */

  }



  getSectionsToRender() {
    return [
      {
        id: "mini-cart-drawer",
      },
      {
        id: "cart-notification-count",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        if (parsedState.item_count > 0) {
          this.updateLiveRegions(line, parsedState.item_count);
        }
        
        this.checkCartForFreeGift(parsedState); // Re-check free gift eligibility after quantity change
        
        
      })
      .catch(() => {
        console.error("Error updating cart");
      })
      .finally(() => {
        document.querySelector(".cart_action_drawer_overlay").classList.remove("active");
        this.notification.classList.remove("loading-bar");
      });
  }

  checkCartForFreeGift(cart) {

  
    
    const cartTotal = cart.total_price / 100; // Convert to base currency (e.g., INR)
    const freeGiftItem = cart.items.find((item) => item.variant_id === FREE_GIFT_VARIANT_ID);

    // If the cart total is >= MIN_CART_TOTAL, add the free gift if it's not already in the cart
    if (cartTotal >= MIN_CART_TOTAL) {
      if (!freeGiftItem) {
        this.addFreeGiftToCart();
      }
       // Find the input field with the class '.pid_50852594745641' and set its value to 1
      const freeGiftInput = document.querySelector('.pid_50852594745641 .quantity__input');

      if (freeGiftInput) {
        freeGiftInput.value = 1; // Set the quantity to 1
      }
    } else {
      // If the cart total drops below the threshold, remove the free gift if it's in the cart
      if (freeGiftItem) {
        //this.rmv();
        this.removeFreeGiftFromCart(freeGiftItem.key);
      }
             // Find the input field with the class '.pid_50852594745641' and set its value to 1
            /*const freeGiftInput = document.querySelector('.pid_50852594745641 .quantity__input');

            if (freeGiftInput) {
              freeGiftInput.value = 0; // Set the quantity to 1
            }*/

            var element = document.querySelector('.pid_50852594745641 cart-remove-button-2.cart-close-icon');

            // Check if the element exists before trying to click
            if (element) {
                // Trigger a click event on the selected element
                element.click();
            } else {
                console.log('Element not found');
            }
            
            

    }
  }



  addFreeGiftToCart() {
    const body = JSON.stringify({
      items: [{ id: FREE_GIFT_VARIANT_ID, quantity: 1 }],
    });

    fetch('/cart/add.js', {
      method: 'POST',
      body: body,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => response.json())
      .then(() => {
        console.log("Free gift added to cart");
        this.updateCartPage();
        customElements.define("cart-notification", CartNotification);
      })
      .catch((error) => {
        console.error("Error adding free gift:", error);
      })
      .finally(() => {
        document.querySelector(".cart_action_drawer_overlay").classList.add("active");
        this.notification.classList.add("loading-bar");
      });

      

        
    }
    

  removeFreeGiftFromCart(itemKey) {
    const body = JSON.stringify({
      id: itemKey,
      quantity: 0,
    });

    fetch('/cart/change.js', {
      method: 'POST',
      body: body,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => response.json())
      .then(() => {
        console.log("Free gift removed from cart");
        
        this.updateCartPage();
        customElements.define("cart-notification", CartNotification);
      })
      .catch((error) => {
        console.error("Error removing free gift:", error);
      })
      .finally(() => {
        document.querySelector(".cart_action_drawer_overlay").classList.add("active");
        this.notification.classList.add("loading-bar");
      });
  }

  updateCartPage() {
    fetch('/cart?view=drawer')
      .then((response) => response.text())
      .then((data) => {
        const cartDrawer = document.querySelector('.cart-drawer');
        if (cartDrawer) {
          cartDrawer.innerHTML = data;
        }
      });
      // Fetch the content of the cart notification section every 5 seconds
       
  fetch('/cart-notification-url')  // Replace with the URL that returns the cart-notification-product
    .then(response => response.text())  // Get the response as text (HTML content)
    .then(data => {
      // Find the part of the response that contains the cart notification product
      const cartNotification = new DOMParser().parseFromString(data, 'text/html');
      
      // Extract the HTML of the cart notification
      const cartNotificationContent = cartNotification.querySelector('#cart-notification-product');

      // Now update your current DOM with the new content
      if (cartNotificationContent) {
      
        document.getElementById('cart-notification-product').innerHTML = cartNotificationContent.innerHTML;
      }
    })
    .catch(error => console.log('Error fetching cart notification:', error))
    .finally(() => {
        document.querySelector(".cart_action_drawer_overlay").classList.remove("active");
        this.notification.classList.remove("loading-bar");
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.remove("no-js-inline");
    } else {
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.add("no-js-inline");
    }
    this.currentItemCount = itemCount;
  }

  deleteQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        this.checkCartForFreeGift(parsedState);
      })
      .catch(() => {
        console.error("Error deleting quantity");
      })
      .finally(() => {
        document.querySelector(".cart_action_drawer_overlay").classList.remove("active");
        this.notification.classList.remove("loading-bar");
      });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("mini-cart-drawer");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.miniCartClose());
  }

  onClickMiniCart() {
    document
      .getElementById("mini-cart-drawer")
      .classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");
    

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    document.getElementById("mini-cart-drawer").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
    removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);

